import React from "react";
import { ReactQueryDevtools } from "react-query/devtools";

export default function ReactQueryDevTools() {
  if (process.env.NODE_ENV !== "production") return <ReactQueryDevtools />;
  return null;
}
